// GENERATED FILE - DO NOT MODIFY

export enum PaymentMethodHolderTypeDto {
    User = "User",
    Company = "Company",
}